const icon = require('vue-svgicon');
icon.register({
    'badge-sale-light': {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        data: `<circle pid="0" cx="12" cy="12" r="12" _fill="#EDFF21"/>`,
    },
});
